export default __webpack_public_path__ + "static/media/JSpeed_Scoreboard.ad4a1690.png";